import React from "react";
import { Link, useLocation } from "react-router-dom";

function InternalLink({ to, children, preserveQuery = false, ...rest }) {
    const location = useLocation();
    const { pathname, search } = location;

    // If preserveQuery is true, append current query parameters to the new path
    const finalTo = preserveQuery && search ? `${to}${search}` : to;

    return (
        <Link data-active={pathname === to} to={finalTo} {...rest}>
            {children}
        </Link>
    );
}

export default InternalLink;
